/**
 * Caches the current member's IANA time zone id, pushed down by the SessionHub SignalR
 * connection on connect (see entrypoint.ts and SessionHub.SetTimezone).
 *
 * Reads are synchronous so callers in sync contexts (e.g. Vue setup / reactive model
 * construction) can resolve "today" in the member's zone. Until the push arrives - or for
 * anonymous users, where nothing is pushed - it falls back to the browser's own zone, which
 * is what the app reports to the backend as the member's zone in the first place.
 */
let cached: string | null = null;

export function setUserTimeZone(timeZoneId: string): void {
	cached = timeZoneId;
}

export function currentTimeZoneId(): string {
	return cached ?? Intl.DateTimeFormat().resolvedOptions().timeZone;
}
